var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7955 19.3725V16.6496C25.7955 13.0122 23.1766 9.98791 19.7469 9.38511V8.52252C19.7469 7.83659 19.1857 7.27539 18.4998 7.27539C17.8139 7.27539 17.2527 7.83659 17.2527 8.52252V9.38511C13.8231 9.98789 11.2041 13.0122 11.2041 16.6496V19.3725C10.0298 19.9025 9.20874 21.0769 9.20874 22.4487C9.20874 24.309 10.7261 25.8264 12.5864 25.8264H17.2631V27.2294C17.2631 27.9153 17.8243 28.4765 18.5103 28.4765C19.1962 28.4765 19.7574 27.9153 19.7574 27.2294V25.816H24.4341C26.2944 25.816 27.8118 24.2986 27.8118 22.4384C27.791 21.0769 26.97 19.9025 25.7956 19.3725H25.7955ZM18.4998 11.7651C21.15 11.7651 23.3012 13.9579 23.3012 16.6496V19.0711H13.6881V16.6496C13.6985 13.9579 15.8498 11.7651 18.5 11.7651H18.4998ZM24.4237 23.3213H12.5757C12.0873 23.3213 11.6924 22.9264 11.6924 22.4379C11.6924 21.9494 12.0873 21.5545 12.5757 21.5545H24.4237C24.9121 21.5545 25.3071 21.9494 25.3071 22.4379C25.2967 22.9264 24.9017 23.3213 24.4237 23.3213Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0C8.64747 0 0.625 8.02323 0.625 17.875C0.625 27.7268 8.64823 35.75 18.5 35.75C28.3518 35.75 36.375 27.7268 36.375 17.875C36.375 8.02323 28.3518 0 18.5 0ZM18.5 33.2567C10.0195 33.2567 3.1183 26.3559 3.1183 17.875C3.1183 9.39407 10.0191 2.4933 18.5 2.4933C26.9809 2.4933 33.8817 9.39407 33.8817 17.875C33.8817 26.3559 26.9809 33.2567 18.5 33.2567Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/notification-bell-icon.7e25a52b71a5dd3cf184cb1f8926a9b6.svg";
export { ForwardRef as ReactComponent };